import ReactGA from "react-ga4";

const GA_TRACKING_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-TV6S38G8QG";

export const initGA = () => {
  if (!GA_TRACKING_ID) {
    console.warn("Google Analytics Measurement ID not configured");
    return;
  }
  ReactGA.initialize(GA_TRACKING_ID);
};

export const logPageView = (path, search = "") => {
  const fullPath = path + search;
  ReactGA.send({
    hitType: "pageview",
    page: fullPath,
    page_location: window.location.href,
  });
};

export const logEvent = (category, action, label) => {
  ReactGA.event({ category, action, label });
};

// File Upload Events
export const trackFileUploadStart = (fileSize) => {
  ReactGA.event({
    category: "file_upload",
    action: "upload_started",
    value: fileSize,
  });
};

export const trackFileUploadSuccess = (fileSize) => {
  ReactGA.event("file_upload_success", {
    category: "file_upload",
    file_size_bytes: fileSize,
  });
};

export const trackFileUploadError = (errorMessage) => {
  ReactGA.event("file_upload_error", {
    category: "file_upload",
    error_message: errorMessage || "Unknown error",
  });
};

// Analysis Events
export const trackAnalysisStart = () => {
  ReactGA.event({
    category: "analysis",
    action: "analysis_started",
  });
};

export const trackAnalysisComplete = () => {
  ReactGA.event("analysis_complete", {
    category: "analysis",
  });
};

export const trackAnalysisError = (errorMessage) => {
  ReactGA.event("analysis_error", {
    category: "analysis",
    error_message: errorMessage || "Analysis failed",
  });
};

// Search Events
export const trackSearchQuery = (searchTerm, searchType) => {
  ReactGA.event("search_query", {
    category: "search",
    search_term: searchTerm,
    search_type: searchType, // 'sha' or 'filename'
  });
};

export const trackSearchResults = (resultCount, searchTerm) => {
  ReactGA.event("search_results_displayed", {
    category: "search",
    result_count: resultCount,
    search_term: searchTerm,
  });
};

// User Action Events
export const trackReportShare = (analysisId) => {
  ReactGA.event("report_shared", {
    category: "report",
    analysis_id: analysisId,
  });
};

export const trackReportPrint = (analysisId) => {
  ReactGA.event("report_printed", {
    category: "report",
    analysis_id: analysisId,
  });
};

export const trackSampleFileClick = (sampleId) => {
  ReactGA.event("sample_file_selected", {
    category: "sample",
    sample_id: sampleId,
  });
};

// User Signup Events
export const trackSignUp = (referralSource) => {
  ReactGA.event("sign_up", {
    category: "user",
    method: "email",
    referral_source: referralSource || "not_specified",
  });
};

// Error Tracking
export const trackError = (errorType, errorMessage, context) => {
  ReactGA.event("error_occurred", {
    error_type: errorType,
    error_message: errorMessage,
    error_context: context,
  });
};
